import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./utils/AuthContext";
import { NavigationProvider } from "./utils/NavigationContext";
import { ToastProvider } from "./components/Toast";
import SignupForm from "./components/Signup";
import LoginForm from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import CalendarDashboard from "./components/Dashboard";
import VideoForm from "./components/addVideo";
import ViewVideos from "./components/Video";
import PurchaseOrderForm from "./components/PurchaseOrder";
import PurchaseOrders from "./components/PurchaseOrderTable";
import VideoStylesTable from "./components/videoStyle/videoStyleTable";
import StoryTypeTable from "./components/storyType/storyTypeTable";
import DashboardLoader from "./components/loader/DashboardLoader";

// Protected Route Component
const ProtectedRoute = ({ element, requiredRole }) => {
  const { userRole, isAuthenticated, loading } = useAuth();
  if (loading) {return <div className="flex  justify-center items-center h-screen"><DashboardLoader /> </div>
  }
  if (!isAuthenticated || !userRole ) {
    return <Navigate to="/login" />;
  }

  if(requiredRole && userRole !== requiredRole) {
    return <Navigate to="/dashboard" />;
  }

  return element;
};


const App = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <NavigationProvider>
            <div className="App">
              <Routes>
              <Route path="/" element={<ProtectedRoute element={<CalendarDashboard />} />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/signup" element={<SignupForm />} />
              <Route path="/dashboard" element={<ProtectedRoute element={<CalendarDashboard />} />} />
              <Route path="/add-video" element={<ProtectedRoute element={<VideoForm />} />} />
              <Route path="/update-video" element={<ProtectedRoute element={<VideoForm />} />} />
              <Route path="/videos" element={<ProtectedRoute element={<ViewVideos />} />} />
              <Route path="/create-purchase-order" element={<ProtectedRoute element={<PurchaseOrderForm />}  requiredRole={"ADMIN"}/>} />
              <Route path="/purchase-order" element={<ProtectedRoute element={<PurchaseOrders />} requiredRole={"ADMIN"} />} />
              <Route path="/video-style" element={<ProtectedRoute element={<VideoStylesTable />} />} />
              <Route path="/story-type" element={<ProtectedRoute element={<StoryTypeTable />} />} />
            </Routes>
          </div>
          </NavigationProvider>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
